import MUILoadingButton from '@mui/lab/LoadingButton';
import React from 'react';
/**
 * This component requires to be a standalone component - importing the
 * MUILoadingButton directly to a component (e.g. Button) causes
 * "heap out of memory" error (on CI + sometimes on local).
 * LoadingButtonProps also cannot be imported from @mui/lab,
 * causing the same error.
 *
 * See an example run:
 * https://github.com/BranchMetrics/branch-neo-components/runs/5817284958?check_suite_focus=true
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function LoadingButton(props) {
    // eslint-disable-next-line react/jsx-props-no-spreading
    return React.createElement(MUILoadingButton, Object.assign({}, props));
}
//# sourceMappingURL=LoadingButton.js.map